import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

export const BillingSameAsDeliveryLabel = () => {
  const { formatMessage } = useIntl();

  return <span>{formatMessage(messages.billingAddressIsSameAsDeliveryAddress)}</span>;
};

export const SaveCardForFutureLabel = () => {
  const { formatMessage } = useIntl();

  return <span>{formatMessage(messages.saveCardDisclaimer)}</span>;
};

const messages = defineMessages({
  saveCardDisclaimer: {
    id: 'saveCardDisclaimer',
    defaultMessage:
      'Save Card, by saving your card you consent for your card to be stored and used for purchases.',
    description: 'Text for card disclaimer',
  },

  billingAddressIsSameAsDeliveryAddress: {
    id: 'billingAddressIsSameAsDeliveryAddress',
    defaultMessage: 'Billing address is same as delivery address.',
    description: 'Text for the billing address disclaimer',
  },
});
